/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseThreadResult } from '../../models/api-response-thread-result';
import { ChatImport } from '../../models/chat-import';

export interface ImportChatHistory$Params {
  'x-api-requestId'?: string;
      body: ChatImport
}

export function importChatHistory(http: HttpClient, rootUrl: string, params: ImportChatHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseThreadResult>> {
  const rb = new RequestBuilder(rootUrl, importChatHistory.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseThreadResult>;
    })
  );
}

importChatHistory.PATH = '/v1/api/ui/conversation/history';
